import { render, staticRenderFns } from "./photos_after.vue?vue&type=template&id=9365e836&scoped=true&"
import script from "./photos_after.vue?vue&type=script&lang=js&"
export * from "./photos_after.vue?vue&type=script&lang=js&"
import style0 from "./photos_after.vue?vue&type=style&index=0&id=9365e836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365e836",
  null
  
)

export default component.exports